var interactions = new Map();
export default interactions;